export type Locale = 'en' | 'es' | 'es-PE' | 'es-EC'

export const DEFAULT_LOCALE: Locale = 'en'

const normalizeLocaleTag = (value: string): string => value.trim().replace('_', '-').toLowerCase()

export const resolveBrowserLocale = (): Locale => {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE

  const candidates: string[] = []
  if (Array.isArray(navigator.languages)) {
    candidates.push(...navigator.languages)
  }
  if (typeof navigator.language === 'string') {
    candidates.push(navigator.language)
  }

  for (const raw of candidates) {
    const normalized = normalizeLocaleTag(raw)
    if (normalized === 'es-pe') return 'es-PE'
    if (normalized === 'es-ec') return 'es-EC'
    if (normalized.startsWith('es')) return 'es'
    if (normalized.startsWith('en')) return 'en'
  }

  return DEFAULT_LOCALE
}

export const getLocaleFallbackChain = (locale: Locale): Locale[] => {
  if (locale === 'es-PE' || locale === 'es-EC') return [locale, 'es', 'en']
  if (locale === 'es') return ['es', 'en']
  return ['en']
}
